// The site's local clock, for the sun tool. Australian standard time by longitude:
// west of 129 E = WA (AWST, UTC+8); 129-138 E = NT/SA (ACST, UTC+9.5); east of 138 E = QLD and
// the east coast (AEST, UTC+10). Daylight saving is ignored on purpose: the tool sets a fixed
// local hour for lighting. Known approximation: SA east of 138 E would read AEST.
export interface SiteClock {
  offsetHours: number;
  label: string;
}

export function siteClockForLon(lon: number | null): SiteClock {
  if (lon == null || lon < 129) return { offsetHours: 8, label: "AWST" };
  if (lon < 138) return { offsetHours: 9.5, label: "ACST" };
  return { offsetHours: 10, label: "AEST" };
}

/** UTC instant for `hour` local time (e.g. 10.5 = 10:30) on `now`'s UTC calendar day. */
export function utcDateForLocalHour(now: Date, hour: number, offsetHours: number): Date {
  const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  d.setUTCHours(0, Math.round((hour - offsetHours) * 60), 0, 0);
  return d;
}
